import { StyledBreakWordContainer } from '../../styled';
import AccessFolder from './Columns/AccessFolder';
import Action from './Columns/Action';
import ExecutedOn from './Columns/ExecutedOn';
import PartialDelivery from './Columns/PartialDelivery';
import PortfolioSheet from './Columns/PortfolioSheet';
import Priority from './Columns/Priority';
import Remark from './Columns/Remark';
import TakeOff from './Columns/TakeOff';
import Tat from './Columns/Tat';
import UpdateStatus from './Columns/UpdateStatus';

export const getPortfolioColumns = (refetchData, setPortfolioData, handleFolderClick) => {
  const columns = [
    {
      Header: 'Portfolio Name',
      accessor: 'portfolio_name',
      isSticky: true,
      Cell: ({ row }) => {
        return <AccessFolder row={row} handleFolderClick={handleFolderClick} />;
      }
    },
    {
      Header: 'Portfolio Folder ID',
      accessor: 'folder',
      Cell: ({ row }) => {
        return (
          <div className='flex w-40'>
            <StyledBreakWordContainer>{row?.values?.folder ? row.values.folder : '-'}</StyledBreakWordContainer>
          </div>
        );
      }
    },
    {
      Header: 'Email',
      accessor: 'executed_by',
      Cell: ({ row }) => {
        return (
          <div className='flex w-40'>
            <StyledBreakWordContainer>
              {row?.values?.executed_by?.email ? row.values.executed_by.email : '-'}
            </StyledBreakWordContainer>
          </div>
        );
      }
    },
    {
      Header: 'No. of properties',
      accessor: 'no_of_property',
      Cell: ({ row }) => {
        return row?.values?.no_of_property ? (
          <div className='flex justify-center w-40'>{row.values.no_of_property}</div>
        ) : (
          '-'
        );
      },
      align: 'center',
      allowColumnConfig: true
    },

    {
      Header: 'Takeoff Type',
      accessor: 'takeoff_type',
      Cell: ({ row }) => {
        return <TakeOff row={row} />;
      },
      align: 'center'
    },
    {
      Header: 'Executed On',
      accessor: 'executed_on',
      Cell: ({ row }) => {
        return <ExecutedOn row={row} />;
      },
      align: 'center'
    },
    {
      Header: 'Received Date',
      accessor: 'received_date',
      Cell: ({ row }) => {
        return (
          <div className='flex justify-center w-40'>{row.values.received_date ? row.values.received_date : '-'}</div>
        );
      },
      align: 'center',
      allowColumnConfig: true
    },
    {
      Header: 'Expected TAT',
      accessor: 'expected_tat',
      Cell: ({ row }) => {
        return (
          <div className='flex justify-center w-40'>{row.values.expected_tat ? row.values.expected_tat : '-'}</div>
        );
      },
      align: 'center',
      allowColumnConfig: true
    },
    {
      Header: 'TAT',
      accessor: 'tat',
      Cell: ({ row }) => {
        return <Tat row={row} />;
      },
      align: 'center',
      allowColumnConfig: true
    },
    {
      Header: 'Partial Delivery',
      accessor: 'partial_delivery',
      Cell: ({ row }) => {
        return <PartialDelivery row={row} />;
      },
      align: 'center'
    },
    {
      Header: 'Status',
      accessor: 'status',
      Cell: ({ row }) => {
        return <UpdateStatus row={row} setPortfolioData={setPortfolioData} />;
      },
      align: 'center'
    },
    {
      Header: 'Priority',
      accessor: 'priority',
      Cell: ({ row }) => {
        return <Priority row={row} />;
      },
      align: 'center',
      allowColumnConfig: true
    },
    {
      Header: 'Remark',
      accessor: 'remark',
      Cell: ({ row }) => {
        return <Remark row={row} />;
      },
      align: 'center'
    },
    {
      Header: 'Portfolio Sheet',
      accessor: 'portfolio_sheet',
      Cell: ({ row }) => {
        return <PortfolioSheet row={row} />;
      },
      align: 'center'
    },
    {
      Header: 'Action',
      accessor: 'action',
      align: 'center',
      Cell: ({ row }) => {
        return <Action row={row} refetchData={refetchData} />;
      },
      isSticky: true
    }
  ];
  return columns;
};
